import { LandingMetaPixel, MetaPixelEvents } from '../types'

/**
 * Meta Pixel (Facebook/Instagram). Por defecto DESACTIVADO: ninguna landing
 * existente o nueva carga el Pixel hasta que la organización o la propia
 * landing lo configuren explícitamente.
 */
export const DEFAULT_META_PIXEL_EVENTS: Required<MetaPixelEvents> = {
  pageView: true,
  lead: true,
  whatsapp: true,
  schedule: false,
}

export const DEFAULT_LANDING_META_PIXEL: LandingMetaPixel = {
  enabled: false,
  pixelId: undefined,
  events: { ...DEFAULT_META_PIXEL_EVENTS },
  override: false,
}

/**
 * Completa solo las claves ausentes, igual que `withFloatingDefaults` y
 * `withBackgroundDefaults`: un valor guardado explícitamente (incluido
 * `false`) se conserva, y una landing que nunca tocó Meta Pixel recibe el
 * valor por defecto (desactivado, cero peticiones).
 */
export function withMetaPixelDefaults(value?: unknown): LandingMetaPixel {
  const config = (value ?? {}) as LandingMetaPixel
  return {
    ...DEFAULT_LANDING_META_PIXEL,
    ...config,
    events: { ...DEFAULT_META_PIXEL_EVENTS, ...(config.events ?? {}) },
  }
}

/** Descripción de cada evento, para el selector del constructor. */
export const META_PIXEL_EVENT_INFO: {
  key: keyof MetaPixelEvents
  label: string
  description: string
  disabled?: boolean
}[] = [
  {
    key: 'pageView',
    label: 'PageView',
    description: 'Al entrar un visitante en la landing pública.',
  },
  {
    key: 'lead',
    label: 'Lead',
    description:
      'Solo cuando el formulario se ha guardado correctamente (nunca al pulsar «Enviar»).',
  },
  {
    key: 'whatsapp',
    label: 'WhatsApp',
    description: 'Al pulsar el botón de WhatsApp de la página de gracias.',
  },
  {
    key: 'schedule',
    label: 'Schedule',
    description:
      'Reserva confirmada en el calendario. No disponible todavía: el bloque admite cualquier agenda externa y no hay forma fiable de saber si hubo reserva.',
    disabled: true,
  },
]
